import { useMemo } from 'react';
import { useTheme, Skeleton, Box } from '@mui/material';
import { ApolloError } from '@apollo/client';

import { Typography } from '@occc-app/design-system';
import { TimeSeriesDataPoint } from '@occc/graphql';
import { parseDate } from '@occc-app/lib/date';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { MetricLineChart } from '@occc/ui-design-system';

import { tickMonthAndDateSlashedFormatter } from './scan-data-report-lines-chart.utils';

import { CHART_HEIGHT } from '../scan-data-overview.constants';

export type ScanDataReportLinesChartProps = {
  loading: boolean;
  error: ApolloError | undefined;
  data: TimeSeriesDataPoint[] | undefined;
};

const MAX_TICKS_COUNT = 10;

export const ScanDataReportLinesChart = ({
  loading,
  error,
  data,
}: ScanDataReportLinesChartProps) => {
  const theme = useTheme();

  const metrics = useMemo(() => {
    return data?.map(({ date, value }) => ({ date: parseDate(date), value }));
  }, [data]);

  if (loading && !metrics) {
    return <Skeleton variant='rectangular' width='100%' height={CHART_HEIGHT} />;
  }

  if (error || !metrics) {
    return (
      <Box p={4} height={CHART_HEIGHT}>
        <Typography color='error'>Something went wrong. Please try again.</Typography>
      </Box>
    );
  }

  return (
    <MetricLineChart
      height={CHART_HEIGHT}
      dateTickFormatter={tickMonthAndDateSlashedFormatter}
      lineColor={theme.palette.primary.main}
      metrics={metrics}
      maxTicksCount={MAX_TICKS_COUNT}
    />
  );
};
